import { Navigate, useLocation } from "react-router-dom";

function hasLoggedInSession() {
  if (!localStorage.getItem("token")) return false;
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return Boolean(user?.user_id);
  } catch {
    return false;
  }
}

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  if (!hasLoggedInSession()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
